var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cddcfe",
    d: "M7.657 8.33h-1.33v-1c0-.368.297-.667.665-.667a1 1 0 10.13-1.991.998.998 0 00-1.109.795l-1.305-.262A2.33 2.33 0 016.992 3.33a2.335 2.335 0 11.665 4.57zm.006.667v1.333H6.33V8.997zm6-2a6.667 6.667 0 10-13.333 0 6.667 6.667 0 0013.333 0z"
  })));
}
export default __webpack_public_path__ + "static/_/shared/assets/svg/circle-question.svg";
export { SvgCircleQuestion as ReactComponent };